(() => {
  const selector = 'quantity-input input.quantity__input[type="number"][name="quantity"], quantity-input input.quantity__input[type="number"][name="updates[]"]';
  function syncButtons(input) {
    const quantityInput = input.closest('quantity-input');
    if (!quantityInput) return;
    const value = Number.parseInt(input.value, 10);
    const minus = quantityInput.querySelector('button[name="minus"]');
    const plus = quantityInput.querySelector('button[name="plus"]');
    if (minus) minus.disabled = !Number.isFinite(value) || value <= 1;
    if (plus) plus.disabled = !Number.isFinite(value) || value >= 3;
  }
  function guard(input, updateCart) {
    if (!(input instanceof HTMLInputElement) || !input.matches(selector)) return;
    const isCart = input.name === 'updates[]';
    input.readOnly = true;
    input.setAttribute('readonly', '');
    input.setAttribute('aria-readonly', 'true');
    input.setAttribute('inputmode', 'none');
    input.min = '1';
    input.max = '3';
    input.step = '1';
    if (!isCart) {
      input.dataset.min = '1';
      input.dataset.max = '3';
      input.dataset.cartQuantity = '0';
    }
    const current = Number.parseInt(input.value, 10);
    const next = Number.isFinite(current) ? Math.min(3, Math.max(1, current)) : 1;
    const changed = current !== next;
    if (changed) input.value = String(next);
    syncButtons(input);
    if (isCart && changed && updateCart && input.dataset.codClampQueued !== 'true') {
      input.dataset.codClampQueued = 'true';
      window.setTimeout(() => {
        if (!input.isConnected) return;
        delete input.dataset.codClampQueued;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }, 150);
    }
  }
  function scan(root, updateCart = true) {
    if (root instanceof Element && root.matches(selector)) guard(root, updateCart);
    if (!(root instanceof Document || root instanceof DocumentFragment || root instanceof Element)) return;
    root.querySelectorAll(selector).forEach((input) => guard(input, updateCart));
  }
  document.addEventListener('beforeinput', (event) => {
    if (event.target instanceof HTMLInputElement && event.target.matches(selector)) event.preventDefault();
  }, true);
  document.addEventListener('keydown', (event) => {
    if (event.target instanceof HTMLInputElement && event.target.matches(selector) && !['Tab', 'Shift'].includes(event.key)) event.preventDefault();
  }, true);
  document.addEventListener('input', (event) => guard(event.target, false), true);
  document.addEventListener('change', (event) => guard(event.target, false), true);
  document.addEventListener('click', (event) => {
    const button = event.target instanceof Element ? event.target.closest('quantity-input button[name="minus"], quantity-input button[name="plus"]') : null;
    if (!button) return;
    const input = button.closest('quantity-input')?.querySelector('input.quantity__input[type="number"]');
    if (input) window.setTimeout(() => guard(input, false), 0);
  });
  new MutationObserver((mutations) => {
    mutations.forEach((mutation) => mutation.addedNodes.forEach((node) => scan(node, true)));
  }).observe(document.documentElement, { childList: true, subtree: true });
  const start = () => {
    scan(document, true);
    window.setTimeout(() => scan(document, true), 250);
    window.setTimeout(() => scan(document, true), 1000);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();